import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { LogLevelOption } from '../models/log-level-option.interface';
import { logLevelOptionSelectors } from '../state/log-level-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: LogLevelSelectComponent,
        },
    ],
    selector: 'ndt-log-level-select',
    templateUrl: './log-level-select.component.html',
    standalone: false
})
export class LogLevelSelectComponent extends LcsSingleSelectBase<LogLevelOption> implements OnInit {
   logLevels: Observable<LogLevelOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.logLevels = this.store.pipe(select(logLevelOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: LogLevelOption | null): string | null {
      return item ? item.logLevelId : null;
   }

   trackBy(item: LogLevelOption | null) {
      return item ? item.logLevelId : null;
   }
}
